import React, { useState } from 'react'
import styled from 'styled-components'

import { px } from '@/utils/hubScale'

const Root = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${px(12)};
  margin-bottom: ${px(18)};
  padding: ${px(14)} ${px(18)};
  border: ${px(1)} solid #a7f3d0;
  background: #ecfdf5;
  border-radius: ${px(14)};
  color: #065f46;
  font-size: ${px(14)};
  line-height: 1.45;

  svg {
    width: ${px(18)};
    height: ${px(18)};
    flex: none;
    margin-top: ${px(2)};
  }

  b {
    font-weight: 600;
  }
`

const Dismiss = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: ${px(13)};
  cursor: pointer;
  margin-left: auto;
  padding: ${px(4)} ${px(8)};
  border-radius: ${px(8)};

  &:hover {
    background: rgba(6, 95, 70, 0.08);
  }
`

const CheckIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <circle cx="12" cy="12" r="9" />
    <path d="m8.5 12.5 2.5 2.5 4.5-5" />
  </svg>
)

/**
 * "Dossier AZ-0053 créé" (#670 §9).
 *
 * Creating a dossier used to end in a silent page change: no acknowledgement
 * that anything had been saved, and no sight of the reference the commercial
 * will be asked for when they call support. The reference is derived from the
 * project id exactly as `BreadcrumbHeader` derives it, so the two never differ.
 *
 * It also says what has NOT happened — the dossier is created, not sent — since
 * a green banner at the end of a wizard reads as "job done" unless it says
 * otherwise, and a dossier abandoned at 40% is the failure this whole hub is
 * built to avoid.
 */
export const CreatedBanner: React.FC<{ reference: string }> = ({
  reference,
}) => {
  const [dismissed, setDismissed] = useState(false)
  if (dismissed) return null
  return (
    <Root role="status" data-cy="salesman-hub-created-banner">
      <CheckIcon />
      <span>
        Dossier <b>{reference}</b> créé. Il n’est pas encore envoyé&nbsp;:
        complétez les formulaires et les documents ci-dessous, puis envoyez-le.
      </span>
      <Dismiss
        type="button"
        onClick={() => setDismissed(true)}
        data-cy="salesman-hub-created-banner-dismiss"
      >
        Fermer
      </Dismiss>
    </Root>
  )
}
